import { createPostResourceWithUrl, createResource, createResourceWithUrl } from './index';
import axios from 'axios';

/* This file exports resource functions with predefined url, which can be called with parameters for axios request (method, data ...).
To create new resource function createResource function can be used or just create function to call axios with predefined url.
Url for resource function can be defined as a string or as a function,
 which create url string with input parameters such as id or prefix (createUrl function).
*/

export const resourceAccessModules = createResource('/api/v1/accessmodules/');
export const resourceAccessModulesWithLocations = createResource('/api/v2.1/accessmodules/?with=locations');
export const resourceAccessGroups = createResourceWithUrl('/api/v1/accessgroups/');
export const resourceAccessGroupsWithLocations = createResource('/api/v1/accessgroups/?with=locations');
export const resourceAccessGroupsLocations = createResource('/api/v1/accessgroups/locations/');
export const resourceAssignmentAreas = createResource('/api/v2/assignmentareas/');
export const resourceAssignments = createResourceWithUrl('/api/v1/assignmentareas/', 'assignments/');
export const resourceLocations = createResourceWithUrl('/api/v1/assignmentareas/', 'locations/');
export const resourceAllLocations = createResource('/api/v3/locations/');
export const resourceMsgGroups = createResourceWithUrl('/api/v1/assignmentareas/', 'phonenumbers/');
export const resourceStaffGroupsInAA = createResourceWithUrl('/api/v1/assignmentareas/', 'staffgroups/');
export const resourceDuties = createResourceWithUrl('/api/v1/assignmentareas/', 'duties/');
export const resourceModuleConfig = createResourceWithUrl('/api/v1/assignmentareas/', 'modules/');
export const resourceCancelAcousticCalls = createResourceWithUrl(
    '/api/v1/assignmentareas/',
    'cancelacousticcalls/'
);
export const resourceModuleButtonsVisibility = createResourceWithUrl(
    '/api/v4.1/assignmentareas/',
    'modules_buttons_visibility/'
);
export const resourceNotCheckedIn = createResourceWithUrl('/api/v1/assignmentareas/', 'notcheckedin/');
export const resourcePresence = createResourceWithUrl('/api/v1/assignmentareas/', 'presence/');
export const resourceCallTypes = createResource('/api/v2/call-types/');
export const resourceCheckIn = createResource('/api/v1/checkin/');
export const resourceResidentProfile = createResourceWithUrl('/api/v1/residentprofiles/');
export const resourceResidentProfiles = createResource('/api/v1/residentprofiles/');
export const resourceResidentProfilesWithSensors = createResourceWithUrl(
    '/api/v1/residentprofiles/',
    '?with=sensors'
);
export const resourceRoomProfiles = createResource('/api/v1/roomprofiles/');
export const resourceSensorNames = createResource('/api/v1/sensornames/');

export const resourceSchedulers = createResourceWithUrl('/api/v2.1/schedulers/');
export const resourceSchedulersWithTime = createResourceWithUrl('/api/v2.1/schedulers/', '?with=time');

export const resourceStaffGroups = createResource('/api/v1/staffgroups/');
export const resourceStaffGroup = createResourceWithUrl('/api/v1/staffgroups/');
export const resourceStaffMembers = createResource('/api/v1/users/?with=assignmentareas');
export const resourceStaffMember = createResourceWithUrl('/api/v1/users/');
export const resourceAttachDetachAA = createResourceWithUrl('/api/v1/users/', 'assignmentareas/');
export const resourceWirelessDevice = createResourceWithUrl('/api/v1/wirelessmodules/');
export const resourceWirelessDeviceBuddies = createResource('/api/v1/wirelessmodules/buddies/');
export const resourceWirelessDeviceTypes = createResource('/api/v1/wirelessdevicetypes/');
export const resourcePortableDevices = createResource('/api/v3.1/portabledevices/');
export const resourceSuperuserAssignmentareas = createResource('/api/v3.1/superuserassignmentareas');
export const resourceMariTime = createResourceWithUrl('/api/v3.3/mari-time/');
export const resourceMariInfo = createResourceWithUrl('/api/v3.3/mari-info/');

/** Wireless Speech Configuration **/
export const resourceExternalPhones = createResource('/api/v3/externalphones/');

/** Not Check In report **/
export const resourceNotCheckInConfiguration = createResourceWithUrl('/api/v2.2/not-check-in/');
export const resourceNotCheckedInFull = createPostResourceWithUrl('/api/v2.2/notcheckedin/');

/** auto requests **/
export const resourceCardId = ({ cancelToken }) =>
    axios({ method: 'get', url: '/api/v1/cardid/', cancelToken });

export const resourceWirelessAuto = ({ cancelToken }) =>
    axios({ method: 'get', url: '/api/v1/wirelessmodules/auto/', cancelToken });

export const resourceMariPing = createResourceWithUrl('/api/v3.2/mari-ping/');

/** Reporting **/
export const resourceLocationNumberOfCalls = createPostResourceWithUrl(
    '/api/v2.1/reports/1/aggregation/numberofcalls/'
);
export const resourceAverageCallDuration = createPostResourceWithUrl(
    '/api/v2.1/reports/1/aggregation/averageduration/'
);
export const resourceLocationLength = createPostResourceWithUrl('/api/v2.1/reports/1/length/');
export const resourceFullEventCallStatistics = createPostResourceWithUrl(
    '/api/v2.1/reports/2/aggregation/callstatistics/'
);
export const resourceFullEventLength = createPostResourceWithUrl('/api/v2.1/reports/2/length/');
export const resourcePairEventDuration = createPostResourceWithUrl(
    '/api/v2.1/reports/4/aggregation/pairduration/'
);
export const resourcePairEventLength = createPostResourceWithUrl('/api/v2.1/reports/4/length/');
export const resourceExceptionTimeStatistics = createPostResourceWithUrl(
    '/api/v2.1/reports/5/aggregation/timestatistics/'
);
export const resourceExceptionWeekPerformance = createPostResourceWithUrl(
    '/api/v2.1/reports/5/aggregation/weekperformance/'
);
export const resourceExceptionLength = createPostResourceWithUrl('/api/v2.1/reports/5/length/');
export const resourceActivityStatistics = createPostResourceWithUrl(
    '/api/v2.1/reports/6/aggregation/performance/'
);
export const resourceStaffPerformanceLength = createPostResourceWithUrl('/api/v2.1/reports/6/length/');

/** Widget resources **/
export const resourceWidgets = createResourceWithUrl('/api/v2/widgets/');
export const resourceWidgetData = createResourceWithUrl('/api/v2.1/widgets/');
export const resourceWidgetOrder = createResourceWithUrl('/api/v3/widgets/order/');

/** Reports resources **/
export const resourceLocationReport = createPostResourceWithUrl('/api/v2/reports/1/');
export const resourceFullEventReport = createPostResourceWithUrl('/api/v2/reports/2/');
export const resourceAscomEventReport = createResource('/api/v2/reports/3/');
export const resourcePairEventReport = createPostResourceWithUrl('/api/v2/reports/4/');
export const resourceExceptionTimeReport = createPostResourceWithUrl('/api/v2/reports/5/');
export const resourceStaffPerformanceReport = createPostResourceWithUrl('/api/v2/reports/6/');

export const resourceCustomReport = createResourceWithUrl('/api/v2/reports/custom/');

export const resourceReportFile = ({ reportId, docType, data, cancelToken }) =>
    axios({
        method: 'post',
        data,
        url: `/api/v2/reports/${reportId}/${docType}/`,
        responseType: 'blob',
        cancelToken,
    });

/** Duty selector resources **/

export const resourceAssignmentAreasHasSelector = createResourceWithUrl(
    '/api/v3.2/assignmentareas/',
    'has_selector/'
);
export const resourceAssignmentAreasDutiesState = createResourceWithUrl(
    '/api/v3.2/assignmentareas/',
    'duties_state/'
);

export const resourceDutySchedulerOverride = createResourceWithUrl(
    '/api/v3.2/assignmentareas/',
    'duty_scheduler_override/'
);
export const resourceDutySchedulerClear = createResourceWithUrl(
    '/api/v3.2/assignmentareas/',
    'duty_scheduler_clear/'
);

/** MARi Audit Trail **/
export const resourceMariAuditTrail = createResourceWithUrl('/api/v3/mari-audit-trail/');
export const resourceGetPeripherals = createResourceWithUrl('/api/staffserver/v4.1/get_peripherals/');

/** Audit Trail Room configuration history */
export const resourceRoomConfHistory = createResourceWithUrl('/api/mari/v4.1/room-configuration-history/');

/** Settings resources **/

export const resourceAssignmentsConf = createResource('/api/v2/settings/assignments-configuration/');
export const resourceColorScheme = createResource('/api/v2/settings/color-scheme/');
export const resourceOrganizationName = createResource('/api/v2/settings/organization/');
export const resourceTargetTime = createResource('/api/v2/settings/target-time/');
export const resourceAutoLogout = createResource('/api/v3.1/settings/auto-logout/');
export const resourceLogSettings = createResource('/api/v3.1/settings/log-settings/');
export const resourceTabVisibility = createResource('/api/mari/v4/settings/tab-visibility/');
export const resourceTimeFormat = createResource('/api/mari/v4/settings/time-format/');
export const resourceDefaultRecipients = createResource('/api/mari/v4/settings/default-recipients/');

/** Maintenance resources **/

export const resourceStatus = createResource('/api/v2/maintenance/status/');
export const resourceClearLogs = createResource('/api/v2/maintenance/clear/');
export const resourceRunLogParser = createResource('/api/v3.1/maintenance/run-log-parser/');
export const resourceRestore = createResource('/api/v2/maintenance/restore/');
export const resourceClearRoomConfHistory = createResource('/api/mari/v4.2/clear-room-conf-history/');
export const resourceClearAuditTrailLogin = createResource('/api/mari/v4.2/clear-audit-trail-login/');
export const resourceRoomConfHistoryInfo = createResource('/api/mari/v4.2/room-history-info/');
export const resourceAuditTrailLoginInfo = createResource('/api/mari/v4.2/audit-trail-login-info/');

export const resourceCancelNCICalls = createResourceWithUrl('/api/v3.2/cancel_nci_calls/');

/** Help **/
export const resourceGetCustomHelp = ({ page, cancelToken }) =>
    axios({
        method: 'get',
        url: `/static/help/${page}.html`,
        cancelToken,
    });

/** Help **/
export const resourceGetDefaultHelp = ({ page, cancelToken }) =>
    axios({
        method: 'get',
        url: `./static/help/${page}.html`,
        cancelToken,
    });

/** Help **/
export const resourceCheckCustomHelp = ({ cancelToken }) =>
    axios({
        method: 'get',
        url: '/api/v2.1/help/is-custom-not-empty/',
        cancelToken,
    });

/** Auth **/
export const resourceGetAuth = token =>
    axios({
        method: 'get',
        url: '/api/v1/users/me/',
        headers: {
            Authorization: 'Basic ' + token,
        },
        params: {
            _timestamp: Date.now(),
        },
    });
export const resourceIsLoginAllowed = createResource('/api/v3.2/is-mari-login-allowed/');

/** Externals configuration **/
export const resourceGetExternalsConfig = () =>
    axios({
        method: 'get',
        url: '/static/external.json',
    });

export const resourceGetLanguage = () =>
    axios({
        method: 'get',
        url: '../static/custom_language.csv',
    });

export const resourceDefaultLanguage = () =>
    axios({
        method: 'get',
        url: './static/languages/defaultLang.csv',
    });
